const HELP_LINK = "https://help.formfunction.xyz/";

export default HELP_LINK;
